import { IntegrationType } from "./integrationType";

export const isShoperApp = () => [IntegrationType.shoper, IntegrationType.phone_hq].includes(window.sessionStorage.getItem('x-auth-provider'));
export const isLivechatApp = () => window.sessionStorage.getItem('x-auth-provider') === IntegrationType.livechat;
export const isAwsMarketplaceApp = () => window.sessionStorage.getItem('x-auth-provider') === IntegrationType.aws_marketplace;
